module.exports = __webpack_public_path__ + "media/images/avalar-d6f66bbbf6466888fa4700a6d016dbd7.svg";